// @ts-nocheck -- Custom store script; the theme's strict checkJs targets Shopify's own
// annotated modules, not this self-contained component. Runtime is covered by tests.
/**
 * <esim-search> — client-side destination browser + type-ahead.
 *
 * Reads a JSON island of destinations (name, handle, url, flag, fromPrice, hasVoice,
 * isPopular, group) rendered by blocks/main-search.liquid. All rows are built with DOM
 * APIs (names come from merchant data) so nothing is injected as HTML.
 *
 * Two modes, matching the two design states:
 *   browse  — bar focused, nothing typed. Popular / Region / All chips over a flat card
 *             list, capped at pageSize with a MORE button. No group headings or prices.
 *             Popular is location-aware: see POPULAR_BY_COUNTRY below.
 *   search  — shopper is typing. Chips hide; matches are grouped into Country / Regions
 *             with price and chevron, uncapped.
 */

const PHONE_ICON =
'<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.4885 7.63359C9.73005 7.63359 8.99629 7.51027 8.31186 7.28829C8.09604 7.2143 7.85557 7.26979 7.68908 7.43627L6.72101 8.65099C4.97601 7.81857 3.34201 6.24622 2.47259 4.43957L3.67497 3.416C3.84146 3.24335 3.89079 3.00287 3.82296 2.78706C3.59482 2.10263 3.47766 1.36887 3.47766 0.61044C3.47766 0.277473 3.20019 0 2.86722 0H0.733762C0.400794 0 0 0.147986 0 0.61044C0 6.33871 4.76637 11.0989 10.4885 11.0989C10.9263 11.0989 11.0989 10.7105 11.0989 10.3713V8.24403C11.0989 7.91106 10.8214 7.63359 10.4885 7.63359Z" fill="white"/></svg>'

/**
 * The Popular chip: where shoppers FROM a country actually travel TO, keyed by the
 * shopper's ISO country code as detected by Shopify's own geolocation endpoint
 * (browsing_context_suggestions.json — same one the Geolocation app uses, so no
 * third-party service and no permission prompt). POPULAR_DEFAULT covers shoppers
 * whose country can't be detected or isn't listed.
 *
 * Entries are destination names, matched against each destination's name AND handle
 * after popularKey() normalisation, so "united states" finds a "United States"
 * collection whatever its handle spelling. An entry with no matching collection is
 * simply skipped — the list degrades, it never breaks.
 */
const POPULAR_DEFAULT = ['japan', 'thailand', 'vietnam', 'united states', 'united kingdom', 'france', 'singapore', 'italy', 'spain', 'germany', 'australia', 'canada'];

const POPULAR_BY_COUNTRY = {
  KR: ['japan', 'vietnam', 'thailand', 'china', 'taiwan', 'philippines', 'united states', 'hongkong', 'singapore', 'indonesia', 'canada', 'australia'],
  US: ['mexico', 'canada', 'united kingdom', 'italy', 'france', 'dominican republic', 'spain', 'germany', 'japan', 'south korea', 'portugal', 'greece'],
  JP: ['united states', 'south korea', 'vietnam', 'germany', 'singapore', 'france', 'spain', 'united kingdom', 'italy', 'philippines', 'taiwan', 'thailand'],
  CN: ['thailand', 'japan', 'south korea', 'singapore', 'malaysia', 'vietnam', 'united states', 'australia', 'italy', 'france', 'cambodia', 'indonesia'],
  TW: ['japan', 'china', 'south korea', 'vietnam', 'thailand', 'hongkong', 'macau', 'united states', 'philippines', 'singapore', 'malaysia', 'australia'],
  HK: ['china', 'japan', 'taiwan', 'south korea', 'thailand', 'singapore', 'vietnam', 'macau', 'united kingdom', 'united states', 'malaysia', 'canada'],
  GB: ['spain', 'france', 'italy', 'greece', 'portugal', 'united states', 'turkey', 'netherlands', 'germany', 'ireland', 'croatia', 'united arab emirates'],
  AU: ['indonesia', 'new zealand', 'united states', 'thailand', 'japan', 'united kingdom', 'singapore', 'vietnam', 'china', 'fiji', 'cambodia', 'philippines'],
  CA: ['united states', 'mexico', 'cuba', 'dominican republic', 'united kingdom', 'france', 'italy', 'jamaica', 'germany', 'japan', 'spain', 'south korea'],
  SG: ['malaysia', 'indonesia', 'thailand', 'japan', 'australia', 'china', 'south korea', 'vietnam', 'india', 'united kingdom', 'taiwan', 'united states'],
  DE: ['spain', 'italy', 'austria', 'turkey', 'france', 'croatia', 'greece', 'netherlands', 'poland', 'united states', 'egypt', 'thailand'],
  FR: ['spain', 'italy', 'united kingdom', 'morocco', 'germany', 'portugal', 'greece', 'tunisia', 'united states', 'thailand', 'canada', 'japan'],
  IT: ['spain', 'france', 'greece', 'portugal', 'united kingdom', 'germany', 'croatia', 'austria', 'egypt', 'united states', 'tunisia', 'thailand'],
  IN: ['united arab emirates', 'saudi arabia', 'thailand', 'singapore', 'united states', 'qatar', 'kuwait', 'malaysia', 'nepal', 'united kingdom', 'indonesia', 'sri lanka'],
  VN: ['cambodia', 'thailand', 'china', 'south korea', 'japan', 'taiwan', 'singapore', 'malaysia', 'united states', 'australia', 'philippines', 'indonesia'],
  TH: ['laos', 'malaysia', 'china', 'japan', 'south korea', 'vietnam', 'singapore', 'hongkong', 'taiwan', 'united states', 'india', 'united kingdom'],
  MY: ['singapore', 'thailand', 'indonesia', 'australia', 'japan', 'china', 'south korea', 'hongkong', 'vietnam', 'united kingdom', 'taiwan', 'united states'],
  ID: ['malaysia', 'singapore', 'saudi arabia', 'thailand', 'japan', 'south korea', 'china', 'australia', 'hongkong', 'united states', 'vietnam', 'taiwan'],
  PH: ['united states', 'saudi arabia', 'united arab emirates', 'japan', 'hongkong', 'singapore', 'south korea', 'thailand', 'qatar', 'australia', 'kuwait', 'taiwan'],
  ES: ['france', 'italy', 'portugal', 'united kingdom', 'germany', 'morocco', 'united states', 'andorra', 'netherlands', 'greece', 'mexico', 'dominican republic'],
  NL: ['france', 'spain', 'germany', 'italy', 'belgium', 'austria', 'turkey', 'greece', 'portugal', 'united states', 'croatia', 'united kingdom'],
  MX: ['united states', 'canada', 'spain', 'cuba', 'guatemala', 'france', 'dominican republic', 'colombia', 'italy', 'argentina', 'japan', 'united kingdom'],
  BR: ['united states', 'argentina', 'france', 'uruguay', 'spain', 'italy', 'portugal', 'chile', 'mexico', 'united kingdom', 'germany', 'japan'],
  RU: ['turkey', 'united arab emirates', 'egypt', 'thailand', 'china', 'vietnam', 'maldives', 'georgia', 'armenia', 'indonesia', 'sri lanka', 'kazakhstan'],
  PL: ['germany', 'united kingdom', 'italy', 'spain', 'croatia', 'greece', 'turkey', 'czechia', 'austria', 'netherlands', 'bulgaria', 'egypt'],
  CH: ['italy', 'france', 'germany', 'spain', 'austria', 'croatia', 'greece', 'portugal', 'united states', 'turkey', 'united kingdom', 'thailand'],
  NZ: ['australia', 'fiji', 'united states', 'united kingdom', 'indonesia', 'thailand', 'japan', 'singapore', 'china', 'cook islands', 'samoa', 'south korea'],
  AE: ['united kingdom', 'india', 'thailand', 'turkey', 'lebanon', 'egypt', 'saudi arabia', 'switzerland', 'maldives', 'france', 'georgia', 'azerbaijan'],
  BE: ['france', 'spain', 'italy', 'netherlands', 'germany', 'luxembourg', 'greece', 'portugal', 'turkey', 'united states', 'croatia', 'united kingdom'],
  AT: ['italy', 'germany', 'croatia', 'spain', 'greece', 'france', 'turkey', 'hungary', 'slovenia', 'united states', 'thailand', 'egypt'],
  IE: ['spain', 'united kingdom', 'france', 'united states', 'italy', 'portugal', 'germany', 'greece', 'netherlands', 'turkey', 'croatia', 'canada'],
  SE: ['spain', 'greece', 'thailand', 'italy', 'turkey', 'denmark', 'norway', 'germany', 'united kingdom', 'united states', 'france', 'croatia'],
  IL: ['turkey', 'greece', 'cyprus', 'italy', 'united states', 'thailand', 'georgia', 'spain', 'france', 'united kingdom', 'germany', 'india'],
  TR: ['germany', 'azerbaijan', 'georgia', 'bulgaria', 'greece', 'italy', 'netherlands', 'austria', 'ukraine', 'france', 'united kingdom', 'united arab emirates'],
  EG: ['saudi arabia', 'united arab emirates', 'turkey', 'jordan', 'lebanon', 'italy', 'greece', 'kuwait', 'qatar', 'united kingdom', 'germany', 'thailand'],
  ZA: ['zimbabwe', 'mozambique', 'botswana', 'namibia', 'united kingdom', 'mauritius', 'thailand', 'united states', 'portugal', 'united arab emirates', 'tanzania', 'australia'],
  AR: ['brazil', 'chile', 'uruguay', 'united states', 'spain', 'italy', 'paraguay', 'peru', 'france', 'mexico', 'colombia', 'germany'],
  CO: ['united states', 'mexico', 'spain', 'panama', 'peru', 'ecuador', 'brazil', 'argentina', 'chile', 'france', 'italy', 'dominican republic'],
  SA: ['egypt', 'united arab emirates', 'bahrain', 'turkey', 'united kingdom', 'malaysia', 'indonesia', 'thailand', 'jordan', 'morocco', 'switzerland', 'france'],
  QA: ['saudi arabia', 'united arab emirates', 'turkey', 'united kingdom', 'switzerland', 'france', 'thailand', 'maldives', 'egypt', 'jordan', 'malaysia', 'united states'],
  MM: ['thailand', 'singapore', 'china', 'malaysia', 'south korea', 'japan', 'india', 'vietnam', 'united states', 'united arab emirates', 'taiwan', 'indonesia'],
  KH: ['vietnam', 'thailand', 'china', 'south korea', 'japan', 'singapore', 'malaysia', 'united states', 'taiwan', 'laos', 'hongkong', 'australia'],
  LA: ['thailand', 'vietnam', 'china', 'south korea', 'japan', 'singapore', 'malaysia', 'cambodia', 'united states', 'taiwan', 'hongkong', 'australia'],
  BN: ['malaysia', 'singapore', 'thailand', 'indonesia', 'australia', 'united kingdom', 'japan', 'south korea', 'china', 'philippines', 'hongkong', 'taiwan'],
  TL: ['indonesia', 'australia', 'singapore', 'portugal', 'malaysia', 'thailand', 'philippines', 'china', 'vietnam', 'south korea', 'japan', 'united states'],
  PT: ['spain', 'france', 'united kingdom', 'brazil', 'angola', 'morocco', 'italy', 'germany', 'netherlands', 'united states', 'cabo verde', 'mozambique'],
  GR: ['turkey', 'italy', 'cyprus', 'united kingdom', 'germany', 'bulgaria', 'france', 'spain', 'united states', 'albania', 'egypt', 'united arab emirates'],
  DK: ['spain', 'italy', 'thailand', 'germany', 'sweden', 'norway', 'greece', 'turkey', 'france', 'united kingdom', 'united states', 'croatia'],
  NO: ['spain', 'thailand', 'italy', 'greece', 'sweden', 'denmark', 'germany', 'france', 'united kingdom', 'turkey', 'united states', 'croatia'],
  FI: ['spain', 'thailand', 'estonia', 'sweden', 'greece', 'germany', 'italy', 'turkey', 'united kingdom', 'france', 'united states', 'croatia'],
  CZ: ['croatia', 'italy', 'greece', 'spain', 'austria', 'slovakia', 'germany', 'turkey', 'bulgaria', 'hungary', 'poland', 'united states'],
  HU: ['germany', 'austria', 'croatia', 'italy', 'greece', 'spain', 'slovakia', 'romania', 'turkey', 'czechia', 'poland', 'united states'],
  RO: ['italy', 'bulgaria', 'greece', 'spain', 'turkey', 'germany', 'hungary', 'france', 'austria', 'united kingdom', 'croatia', 'united states'],
  UA: ['poland', 'germany', 'turkey', 'egypt', 'romania', 'moldova', 'italy', 'spain', 'czechia', 'bulgaria', 'georgia', 'united arab emirates'],
  IS: ['spain', 'denmark', 'united kingdom', 'united states', 'italy', 'portugal', 'germany', 'france', 'thailand', 'greece', 'sweden', 'norway'],
  KW: ['saudi arabia', 'united arab emirates', 'bahrain', 'turkey', 'united kingdom', 'egypt', 'lebanon', 'thailand', 'france', 'switzerland', 'malaysia', 'united states'],
  BH: ['saudi arabia', 'united arab emirates', 'qatar', 'kuwait', 'turkey', 'united kingdom', 'egypt', 'thailand', 'lebanon', 'malaysia', 'france', 'united states'],
  OM: ['united arab emirates', 'saudi arabia', 'india', 'turkey', 'egypt', 'united kingdom', 'thailand', 'malaysia', 'switzerland', 'france', 'jordan', 'united states'],
  JO: ['saudi arabia', 'united arab emirates', 'egypt', 'turkey', 'lebanon', 'united kingdom', 'united states', 'kuwait', 'qatar', 'germany', 'thailand', 'malaysia'],
  LB: ['france', 'united arab emirates', 'saudi arabia', 'turkey', 'egypt', 'cyprus', 'greece', 'jordan', 'kuwait', 'canada', 'united states', 'germany'],
  NG: ['united kingdom', 'united states', 'united arab emirates', 'south africa', 'ghana', 'canada', 'turkey', 'egypt', 'kenya', 'india', 'qatar', 'france'],
  KE: ['south africa', 'uganda', 'tanzania', 'united kingdom', 'united arab emirates', 'india', 'united states', 'egypt', 'turkey', 'china', 'qatar', 'germany'],
  MA: ['france', 'spain', 'italy', 'belgium', 'netherlands', 'saudi arabia', 'united arab emirates', 'turkey', 'germany', 'egypt', 'united kingdom', 'canada'],
  GH: ['united kingdom', 'united states', 'nigeria', 'south africa', 'united arab emirates', 'canada', 'germany', 'turkey', 'egypt', 'qatar', 'ivory coast', 'kenya'],
  TN: ['france', 'italy', 'libya', 'algeria', 'germany', 'turkey', 'saudi arabia', 'belgium', 'egypt', 'united arab emirates', 'qatar', 'canada'],
  DZ: ['france', 'tunisia', 'spain', 'turkey', 'saudi arabia', 'united arab emirates', 'canada', 'germany', 'belgium', 'egypt', 'qatar', 'united kingdom'],
};

// Spellings a store's collections plausibly use for a list entry (or vice versa),
// mapped onto the list's own spelling — all post-normalisation, letters only.
const POPULAR_ALIASES = {
  usa: 'unitedstates',
  uk: 'unitedkingdom',
  greatbritain: 'unitedkingdom',
  korea: 'southkorea',
  hongkongsar: 'hongkong',
  hongkongsarchina: 'hongkong',
  macao: 'macau',
  turkiye: 'turkey',
  trkiye: 'turkey', // "Türkiye" once the ü is stripped
  uae: 'unitedarabemirates',
  czechrepublic: 'czechia',
  capeverde: 'caboverde',
  ctedivoire: 'ivorycoast', // "Côte d'Ivoire"
  easttimor: 'timorleste',
};

/** "South Korea" / "south-korea" / "Türkiye" → one comparable key. */
function popularKey(value) {
  const key = String(value || '').toLowerCase().replace(/[^a-z]/g, '');
  return POPULAR_ALIASES[key] || key;
}

/**
 * Search-side normalisation, applied to the query, the haystack and the alias table
 * alike: lower-case, accents stripped ("Türkiye" → "turkiye"), dots and apostrophes
 * dropped ("U.S.A." → "usa", "Côte d'Ivoire" → "cote divoire"), every other
 * punctuation mark turned into a space ("United States, Canada" → "united states
 * canada", "Timor-Leste" → "timor leste"), whitespace collapsed. Unlike popularKey()
 * it keeps spaces, so "united states" stays a phrase and can be matched as whole words.
 */
function fold(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[.'\u2019]/g, '')
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim();
}

/** Shortest partial query that may open a synonym ring — see queryTerms(). */
const ALIAS_PREFIX_MIN = 3;

/**
 * Does this synonym ring answer the query? Yes when the query (or the query minus a
 * leading "the") is one of the ring's terms, or when it is the first three-plus
 * letters of one — "united stat" opens the USA ring through "united states". Terms
 * are also tested without their own leading "the", so "phil" reaches "the philippines".
 * Same rule as opensRing() in sections/all-category-tab-content.liquid.
 */
function opensRing(group, q, bare) {
  if (group.includes(q) || group.includes(bare)) return true;
  if (bare.length < ALIAS_PREFIX_MIN) return false;
  return group.some((t) => t.startsWith(bare) || t.replace(/^the /, '').startsWith(bare));
}

const COUNTRY_CACHE_KEY = 'esim-search-country';

// One request per page even with two <esim-search> instances (homepage bar +
// header Destination menu), and one per session via sessionStorage. Resolves to
// an ISO code like 'KR', or '' when detection fails — never rejects.
let countryPromise = null;
function detectedCountry() {
  if (!countryPromise) {
    countryPromise = (async () => {
      try {
        const cached = sessionStorage.getItem(COUNTRY_CACHE_KEY);
        if (cached) return cached;
      } catch { /* storage blocked — detect every page instead */ }
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(`${root}browsing_context_suggestions.json?country%5Benabled%5D=true`, {
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) return '';
        const json = await res.json();
        const iso = String(json?.detected_values?.country?.handle || '').toUpperCase();
        if (iso) {
          try { sessionStorage.setItem(COUNTRY_CACHE_KEY, iso); } catch { /* same */ }
        }
        return iso;
      } catch {
        return '';
      }
    })();
  }
  return countryPromise;
}

class EsimSearch extends HTMLElement {
  /**
   * Room the panel wants below the bar: roughly the capped list (22rem, see
   * .esim-search__results) plus chips and the MORE button. Used only to decide
   * whether opening needs to scroll the bar up first — never as a height.
   */
  static PANEL_TARGET = 520;

  connectedCallback() {
    const dataEl = this.querySelector('.esim-search__data');
    try {
      this.data = JSON.parse(dataEl?.textContent || '[]');
    } catch {
      this.data = [];
    }

    // Synonym rings from snippets/roamigo-search-aliases.liquid: "usa" and "united
    // states" name the same place, but the country collection is titled one way and
    // the regions covering it the other. Folded once here so queryTerms() compares
    // like with like. Missing or malformed island → no aliases, plain search.
    const aliasEl = this.querySelector('.esim-search__aliases');
    try {
      const raw = JSON.parse(aliasEl?.textContent || '[]');
      this.aliasGroups = Array.isArray(raw)
        ? raw.filter(Array.isArray).map((g) => g.map(fold).filter(Boolean))
        : [];
    } catch {
      this.aliasGroups = [];
    }

    this.input = this.querySelector('.esim-search__input');
    this.dropdown = this.querySelector('.esim-search__dropdown');
    this.results = this.querySelector('.esim-search__results');
    this.empty = this.querySelector('.esim-search__empty');
    this.submit = this.querySelector('.esim-search__submit');

    // Browse-mode state: which chip is active, and how many rows are revealed so far.
    this.pageSize = Number(this.dataset.pageSize) || 8;
    this.filter = 'all';
    this.shown = this.pageSize;

    // Destinations by normalised name and handle, for resolving the Popular lists.
    this.byKey = new Map();
    this.data.forEach((d) => {
      [d.name, d.handle].forEach((v) => {
        const k = popularKey(v);
        if (k && !this.byKey.has(k)) this.byKey.set(k, d);
      });
    });

    // Start from the default list so Popular is never empty while detection runs;
    // swap in the shopper's own list whenever the lookup comes back.
    this.popular = this.resolvePopular(POPULAR_DEFAULT);
    detectedCountry().then((iso) => {
      const list = POPULAR_BY_COUNTRY[iso];
      if (!list) return;
      const own = this.resolvePopular(list);
      if (!own.length) return;
      // The catalogue is younger than the lists — a UK shopper's 12 picks resolve
      // to a single collection today. Their own destinations lead, the default
      // list fills the remaining slots, capped at the designed dozen.
      const fill = this.popular.filter((d) => !own.includes(d));
      this.popular = own.concat(fill).slice(0, list.length);
      // Already looking at Popular? Redraw in place rather than on the next open.
      if (this.dropdown && !this.dropdown.hidden && this.filter === 'popular') this.render();
    });

    // The banner section clips/transforms its descendants (rounded/curved bottom), which
    // re-anchors even position:fixed and cuts the dropdown off. Reparent it to <body> so
    // it has no clipping ancestor; positionDropdown() anchors it under the bar in viewport
    // coords.
    //
    // `data-inline-dropdown` opts out: the header Destination dropdown is already a
    // self-contained panel with no clipping ancestor, and its design puts the heading,
    // the bar and the list in ONE box. Reparenting would tear the list out of that box
    // and float it separately (see snippets/destination-menu.liquid).
    this.inlineDropdown = this.hasAttribute('data-inline-dropdown');
    if (this.dropdown && !this.inlineDropdown) document.body.appendChild(this.dropdown);

    // Queried off this.dropdown, not this — the panel now lives on <body>.
    this.chips = this.dropdown ? Array.from(this.dropdown.querySelectorAll('.esim-search__chip')) : [];
    this.moreWrap = this.dropdown?.querySelector('.esim-search__morewrap');
    this.moreBtn = this.dropdown?.querySelector('.esim-search__more');
    // The header renders MORE as a LINK to the collections page; the homepage
    // renders it as a paging button. Both are `.esim-search__more`, so the
    // element itself says which behaviour applies — no placement flag to keep
    // in sync with the markup.
    this.moreIsLink = this.moreBtn?.tagName === 'A';
    this.backBtn = this.dropdown?.querySelector('.esim-search__back');

    this.chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        this.filter = chip.dataset.filter || 'all';
        this.shown = this.pageSize; // a new chip restarts paging
        this.syncChips();
        this.render();
      });
    });

    if (!this.moreIsLink) {
      this.moreBtn?.addEventListener('click', () => {
        this.shown += this.pageSize;
        this.render();
      });
    }

    this.backBtn?.addEventListener('click', () => {
      this.close();
      this.input?.blur();
    });

    this.labels = {
      country: this.dataset.labelCountry || 'Country',
      regions: this.dataset.labelRegions || 'Regions',
      voice: this.dataset.labelVoice || 'Voice',
      soon: this.dataset.labelSoon || 'Coming soon',
      includes: this.dataset.labelIncludes || 'Includes [names]',
    };
    this.coverageMax = 3;
    if (!this.input || !this.results) return;

    this.form = this.querySelector('form');

    this.input.addEventListener('input', () => {
      this.shown = this.pageSize; // editing the query restarts paging
      this.render();
    });
    this.input.addEventListener('focus', () => this.open());
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
      // With a form, Enter submits it (handled below); without one, navigate directly.
      else if (event.key === 'Enter' && !this.form) {
        event.preventDefault();
        this.goToFirst();
      }
    });

    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.goToFirst();
      });
    } else {
      this.submit?.addEventListener('click', () => this.goToFirst());
    }

    this.onDocClick = (event) => {
      // The lift in ensureRoom() runs on focus, i.e. between mousedown and click, so the
      // click that opened the panel lands wherever the page has since scrolled to and
      // reads as an outside click. Ignore clicks that land in the opening moment.
      if (performance.now() - (this.openedAt || 0) < 350) return;

      const inside = this.contains(event.target) || (this.dropdown && this.dropdown.contains(event.target));
      if (!inside) this.close();
    };
    document.addEventListener('click', this.onDocClick);
  }

  disconnectedCallback() {
    if (this.onDocClick) document.removeEventListener('click', this.onDocClick);
    if (this.bound) {
      window.removeEventListener('scroll', this.bound.scroll, { capture: true });
      window.removeEventListener('resize', this.bound.resize);
    }
    // Remove the dropdown we relocated to <body>.
    if (this.dropdown && this.dropdown.parentNode) this.dropdown.remove();
  }

  /**
   * Scroll the bar up only when the panel would not otherwise fit.
   *
   * The bar sits ~569px down a 900px viewport, leaving ~331px — less than the panel
   * wants — so it stretched to fill every pixel and read as glued to the bottom of
   * the screen rather than hanging off the bar. Lifting the bar gives it room to be
   * its natural height. No scroll happens when there is already enough space.
   *
   * Must be 'instant', not 'auto': 'auto' defers to the theme's CSS scroll-behavior,
   * which is smooth — positionDropdown() then measured a bar that was still gliding
   * and pinned the panel to its old spot.
   */
  /**
   * The nearest scrollable ancestor, or null when the window is the scroller.
   * Horizon scrolls an inner `.page-wrapper` (html/body are overflow:hidden), so
   * window.scrollTo is a silent no-op here — the page never moved and the panel
   * stayed squashed into whatever gap was below the bar.
   */
  scrollParent() {
    let node = this.parentElement;
    while (node && node !== document.body && node !== document.documentElement) {
      const cs = getComputedStyle(node);
      if (/(auto|scroll|overlay)/.test(cs.overflowY) && node.scrollHeight > node.clientHeight + 1) return node;
      node = node.parentElement;
    }
    return null;
  }

  ensureRoom() {
    // An inline panel is already anchored below the header and sized by CSS, so
    // there is no gap to make room in. Scrolling the page the moment a shopper
    // hovers a nav item reads as the page jumping away from them.
    if (this.inlineDropdown) return;

    const ref = this.form || this;
    const r = ref.getBoundingClientRect();
    if (window.innerHeight - r.bottom >= EsimSearch.PANEL_TARGET) return;

    const delta = r.top - 80; // move the bar up to just under the sticky header
    if (delta <= 0) return;

    // Our own scroll would otherwise trip the close-on-scroll handler.
    this.selfScroll = true;
    const scroller = this.scrollParent();
    if (scroller) scroller.scrollTo({ top: scroller.scrollTop + delta, behavior: 'instant' });
    else window.scrollTo({ top: window.scrollY + delta, behavior: 'instant' });
    requestAnimationFrame(() => requestAnimationFrame(() => { this.selfScroll = false; }));
  }

  open() {
    this.openedAt = performance.now();
    this.shown = this.pageSize;
    this.syncChips();
    this.render();
    this.dropdown.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
    this.ensureRoom();
    // Belt and braces: if anything (sticky header settling, momentum) moves the bar
    // after the jump, re-measure on the next frame.
    requestAnimationFrame(() => {
      if (!this.dropdown.hidden) this.positionDropdown();
    });
    this.positionDropdown();
    if (!this.bound) {
      this.bound = {
        // Page/container scroll closes the dropdown (a fixed panel can't stay glued to a
        // scrolling bar); scrolling INSIDE the results list is ignored so it stays open.
        scroll: (event) => {
          if (this.dropdown && this.dropdown.contains(event.target)) return;
          if (this.selfScroll) return; // the lift in ensureRoom(), not the shopper
          // The mobile panel isn't glued to the bar, so page scroll must not close it.
          if (this.isMobile()) return;
          this.close();
        },
        resize: () => this.positionDropdown(),
      };
      window.addEventListener('scroll', this.bound.scroll, { capture: true, passive: true });
      window.addEventListener('resize', this.bound.resize);
    }
  }

  close() {
    this.dropdown.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
    if (this.bound) {
      window.removeEventListener('scroll', this.bound.scroll, { capture: true });
      window.removeEventListener('resize', this.bound.resize);
      this.bound = null;
    }
  }

  isMobile() {
    return window.matchMedia('(max-width: 750px)').matches;
  }

  /**
   * Desktop: anchor the fixed panel under the search bar, matching its width.
   * Mobile: span the full viewport width and run from just under the bar to the
   * bottom of the screen (CSS pins `bottom: 0`). The real search bar deliberately
   * stays put in the page rather than being moved into the panel — relocating a
   * focused input blurs it, which drops the keyboard and can bounce the focus
   * handler that opened the panel in the first place.
   */
  positionDropdown() {
    // Inline placements are laid out by CSS inside their own panel. Writing
    // top/left/width here would pin them to viewport coordinates as inline
    // styles, which no stylesheet can override.
    if (this.inlineDropdown) return;

    const mobile = this.isMobile();
    this.dropdown.classList.toggle('is-fullscreen', mobile);

    const ref = this.form || this;
    const r = ref.getBoundingClientRect();

    const gap = 8;
    const top = r.bottom + gap;

    if (mobile) {
      this.dropdown.style.left = '0px';
      this.dropdown.style.width = '100%';
    } else {
      this.dropdown.style.left = `${r.left}px`;
      this.dropdown.style.width = `${r.width}px`;
    }

    this.dropdown.style.top = `${top}px`;

    // A ceiling, not a height: the panel ends with its content and only grows this far.
    // (A flat `max-height: 70vh` is measured from the top of the viewport rather than
    // from the panel, so a bar sitting low in a tall hero pushed the panel — and the
    // MORE button with it — clean off the bottom of the screen.)
    this.dropdown.style.maxHeight = `${Math.max(180, window.innerHeight - top - gap * 2)}px`;
  }

  query() {
    return fold(this.input.value);
  }

  /**
   * Everything the typed query stands for: `typed` is the query itself, `aliases` every
   * other spelling in any alias group the query opens. "usa" → typed "usa", aliases
   * ["united states", "us", "america", …]. A group opens when the query equals one of
   * its terms OR is the start of one, three letters or more: "united stat" is on its
   * way to "united states", so the USA row must already be there before the shopper
   * finishes the word (client request, 2026-09-16). Under three letters nothing
   * opens — "u" would fan out to the USA, UK and UAE rings while the substring match
   * on the haystack already shows every "u" there is. A leading "the" is ignored so
   * "the usa" and "the netherlands" still hit their rings. Null when nothing is typed.
   */
  queryTerms() {
    const q = this.query();
    if (!q) return null;
    const bare = q.replace(/^the( |$)/, '');
    const aliases = new Set();
    (this.aliasGroups || []).forEach((group) => {
      if (opensRing(group, q, bare)) group.forEach((t) => aliases.add(t));
    });
    aliases.delete(q);
    return { typed: q, aliases: Array.from(aliases) };
  }

  /**
   * A destination matches on its own name, and a region also matches on the names of
   * the countries it covers. Typing "Korea" is meant to surface both South Korea itself
   * and the Asia region that includes it — a shopper hunting one country is exactly the
   * shopper a regional eSIM might suit, and they have no way to guess it is called
   * "Asia". `members` is empty for countries, so this costs them nothing.
   *
   * Folded, not just lower-cased: the coverage lists spell "Türkiye" while the country
   * collection is "Turkey", and a shopper types neither the accent nor, usually, the
   * Turkish spelling.
   */
  haystack(d) {
    const members = Array.isArray(d.members) ? d.members.join(' ') : '';
    return fold(`${d.name} ${members}`);
  }

  /**
   * Does this text answer the query? The typed text matches anywhere ("kor" is on its
   * way to "Korea"); an alias only matches as whole words, because the ring for USA
   * carries "us" and a substring "us" would drag in Australia, Austria and Cyprus.
   */
  hits(text, terms) {
    const folded = fold(text);
    if (folded.includes(terms.typed)) return true;
    const padded = ` ${folded} `;
    return terms.aliases.some((a) => padded.includes(` ${a} `));
  }

  /**
   * The second line on a region row: the countries the current query hit, or the plain
   * count when nothing in particular did.
   *
   * Capped at three names plus an overflow count, because a query like "a" matches
   * most of Europe and the line has one row's width to work with. Countries return
   * null — their second line is the price.
   */
  coverageLine(d) {
    if (d.group !== 'region') return null;
    const members = Array.isArray(d.members) ? d.members : [];
    const terms = this.queryTerms();
    // Alias-aware, so a "usa" query names "United States" on the region row — the
    // shopper has to see WHY "United States, Canada" answered their query.
    const hits = terms ? members.filter((m) => this.hits(m, terms)) : [];
    if (!hits.length) return d.countLabel || null;

    const shown = hits.slice(0, this.coverageMax);
    const rest = hits.length - shown.length;
    const names = rest > 0 ? `${shown.join(', ')} +${rest}` : shown.join(', ');
    return this.labels.includes.replace('[names]', names);
  }

  /** List entries → destination objects, in list order; unknown entries drop out. */
  resolvePopular(names) {
    return names.map((n) => this.byKey.get(popularKey(n))).filter(Boolean);
  }

  matches() {
    const terms = this.queryTerms();
    if (!terms) return this.data;
    return this.data.filter((d) => this.hits(this.haystack(d), terms));
  }

  syncChips() {
    this.chips.forEach((chip) => {
      const on = chip.dataset.filter === this.filter;
      chip.classList.toggle('is-active', on);
      chip.setAttribute('aria-pressed', String(on));
    });
  }

  render() {
    if (this.query()) this.renderSearch();
    else this.renderBrowse();
  }

  /** Bar focused, nothing typed: chips + flat capped list + MORE. */
  renderBrowse() {
    this.dropdown.classList.add('is-browse');

    let list = this.data;
    if (this.filter === 'popular') {
      // Location-aware list (or the default while unlocated). The merchant-picked
      // popular_collections setting is only the fallback for the day the built-in
      // lists stop matching any collection at all.
      list = this.popular.length ? this.popular : list.filter((d) => d.isPopular);
    } else if (this.filter === 'region') {
      list = list.filter((d) => d.group === 'region');
    }

    this.results.replaceChildren();

    if (!list.length) {
      this.empty.hidden = false;
      if (this.moreWrap) this.moreWrap.hidden = true;
      return;
    }
    this.empty.hidden = true;

    list.slice(0, this.shown).forEach((item) => this.results.appendChild(this.row(item, true)));

    // A pager is pointless once everything is on screen, so it hides. A link
    // to the catalogue is not — and it must be RESTORED here, because search
    // mode hides the wrapper outright and browse is the only way back.
    if (this.moreWrap) {
      this.moreWrap.hidden = this.moreIsLink ? false : list.length <= this.shown;
    }
  }

  /** Shopper is typing: grouped Country / Regions with price + chevron, uncapped. */
  renderSearch() {
    this.dropdown.classList.remove('is-browse');
    if (this.moreWrap) this.moreWrap.hidden = true;

    const list = this.matches();
    const countries = list.filter((d) => d.group === 'country').slice(0, 100);
    const regions = list.filter((d) => d.group === 'region').slice(0, 100);

    this.results.replaceChildren();

    if (!countries.length && !regions.length) {
      this.empty.hidden = false;
      return;
    }
    this.empty.hidden = true;

    if (countries.length) this.results.appendChild(this.group(this.labels.country, countries));
    if (regions.length) this.results.appendChild(this.group(this.labels.regions, regions));
  }

  group(label, items) {
    const wrap = document.createElement('div');
    wrap.className = 'esim-search__group';

    const title = document.createElement('p');
    title.className = 'esim-search__grouptitle';
    title.textContent = label;
    wrap.appendChild(title);

    items.forEach((item) => wrap.appendChild(this.row(item)));
    return wrap;
  }

  /** @param {boolean} [browse] - browse mode drops the price line and chevron, per design. */
  row(item, browse) {
    const a = document.createElement('a');
    a.className = 'esim-search__row';
    a.href = item.url;
    a.setAttribute('role', 'option');

    if (item.flag) {
      const img = document.createElement('img');
      img.className = 'esim-search__flag';
      img.src = item.flag;
      img.alt = '';
      img.loading = 'lazy';
      a.appendChild(img);
    }

    const info = document.createElement('div');
    info.className = 'esim-search__info';

    // Every row titles itself with its own name, regions included. Regions used to
    // title themselves with the countries they cover, which read well for a three
    // country region and ran off the end of the row once Europe arrived with 33.
    const nameline = document.createElement('div');
    nameline.className = 'esim-search__nameline';
    const name = document.createElement('span');
    name.className = 'esim-search__name';
    name.textContent = item.name;
    nameline.appendChild(name);
    if (item.hasVoice) nameline.appendChild(this.voiceBadge());
    info.appendChild(nameline);

    // What the countries became instead. A region matched on a country the shopper
    // typed has to say so — "Asia" alone, returned for a "japan" query, looks like a
    // bug. Naming the hit turns it into an offer. With no query, or a query that hit
    // the region's own name, the count stands in.
    const coverage = this.coverageLine(item);
    if (coverage) {
      const cover = document.createElement('span');
      cover.className = 'esim-search__coverage';
      cover.textContent = coverage;
      info.appendChild(cover);
    }

    // Shown in both modes. Figma 2047:583 omits it from the browse list, but Anna
    // asked for the price on every row, matching 2047:586. Destinations with no
    // priced product get placeholder copy rather than a price, so the row keeps its
    // height and nothing shifts once products are added. A region that lists its
    // countries is never "coming soon" — it is live, it just has no price yet.
    const hasPlaceholder = !item.fromPrice && !item.countLabel;
    if (item.fromPrice || hasPlaceholder) {
      const from = document.createElement('span');
      from.className = item.fromPrice ? 'esim-search__from' : 'esim-search__from esim-search__from--soon';
      from.textContent = item.fromPrice || this.labels.soon;
      info.appendChild(from);
    }
    a.appendChild(info);

    if (!browse) {
      const chevron = document.createElement('span');
      chevron.className = 'esim-search__chevron';
      chevron.setAttribute('aria-hidden', 'true');
      chevron.textContent = '›';
      a.appendChild(chevron);
    }

    return a;
  }

  voiceBadge() {
    const badge = document.createElement('span');
    badge.className = 'esim-search__voice';
    badge.insertAdjacentHTML('afterbegin', PHONE_ICON);
    const label = document.createElement('span');
    label.textContent = this.labels.voice;
    badge.appendChild(label);
    return badge;
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
    } else if (event.key === 'Enter') {
      event.preventDefault();
      this.goToFirst();
    }
  }

  goToFirst() {
    const first = this.results.querySelector('.esim-search__row');
    if (first instanceof HTMLAnchorElement) window.location.href = first.href;
  }
}

if (!customElements.get('esim-search')) {
  customElements.define('esim-search', EsimSearch);
}

// Shared with assets/footer-popular.js, so the footer column shows the same
// location-aware list as the Popular chip.
export { POPULAR_DEFAULT, POPULAR_BY_COUNTRY, popularKey, detectedCountry };
